import ChangeRuntimeComment from './ChangeRuntimeComment';
import ResolvedChangeRuntimeForm from './ChangeRuntimeForm.container';

export default {
  label: 'Change Runtime',
  value: 'Change Runtime',
  Form: ResolvedChangeRuntimeForm,
  Comment: ChangeRuntimeComment,
  initialState() {
    return {
      proposedEndDate: '',
      selectedLines: {},
    };
  },
  patch(campaign, change) {
    return {
      campaignLines: campaign.campaignLineIds.map(id => {
        if (change.selectedLines[id]) {
          return { id, endDate: change.proposedEndDate };
        }

        return { id };
      }),
    };
  },
};
